// extracted by mini-css-extract-plugin
export default {"text":"TIfOC8qMTi0DCIbssG42","title":"sk6f4oFX5hTfhhLkG7aO","imgEmpty":"l_vnPAwrkHOyjX6JF3d1"};